<template>
  <client-page>
    <main class="nf-page">
      <section>
        <p>404</p>
        <h1>NOT THIS WAY.</h1>
        <p class="nf-copy">찾으시는 페이지가 없어요.</p>
        <router-link to="/">BACK TO MUZIN <span>↗</span></router-link>
      </section>
    </main>
  </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
export default { name: "NotFound", components: { ClientPage } };
</script>

<style scoped>
.nf-page { min-height: 100vh; display: grid; place-items: center; padding: 120px 24px 60px; background: #fff; color: #0a0a0a; }
.nf-page section { text-align: center; }
.nf-page section > p:first-child { margin: 0 0 12px; color: #2457ff; font: 800 12px/1 Inter, sans-serif; letter-spacing: .18em; }
.nf-page h1 { margin: 0; font: 900 clamp(42px, 8vw, 96px)/.95 Inter, sans-serif; letter-spacing: -.06em; }
.nf-copy { margin: 22px 0 30px; color: #6c7078; font-size: 15px; }
.nf-page a { display: inline-flex; gap: 10px; align-items: center; color: #0a0a0a; font: 800 13px/1 Inter, sans-serif; text-decoration: none; border-bottom: 1px solid #0a0a0a; padding-bottom: 6px; }
.nf-page a:hover { color: #2457ff; border-color: #2457ff; }
</style>
